import IconArrowUpLong from "@/app/(components)/generics/Icons/IconArrowUpLong";
import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import {
  barShare,
  HOW_ASSISTANT_ANSWER,
  HOW_ASSISTANT_BARS,
  HOW_ASSISTANT_SOURCES,
} from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";

export default function HowItWorksMockAssistant() {
  const T = useT();

  return (
    <div className={styles.card}>
      <div className={styles.askBar}>
        <span className={styles.askIcon}>
          <IconSparkles />
        </span>
        <span className={styles.askText}>{T(TKey.HOME_MEIDLY_HOW_ASSISTANT_QUESTION)}</span>
        <span className={styles.askSend}>
          <IconArrowUpLong />
        </span>
      </div>

      <span className={styles.answerText}>
        {HOW_ASSISTANT_ANSWER.map((part) => (
          <span key={part.textKey}>
            {`${T(part.textKey)} `}
            <span className={styles.cite}>{part.cite}</span>{" "}
          </span>
        ))}
      </span>

      <div className={styles.chart}>
        <span className={styles.sectionHead}>
          <span className={styles.label}>{T(TKey.HOME_MEIDLY_HOW_ASSISTANT_CHART_TITLE)}</span>
          <span className={styles.meta}>{T(TKey.HOME_MEIDLY_HOW_ASSISTANT_CHART_CAPTION)}</span>
        </span>
        {HOW_ASSISTANT_BARS.map((bar) => (
          <span key={bar.labelKey} className={styles.bar}>
            <span className={styles.barLabel}>{T(bar.labelKey)}</span>
            <span className={styles.barTrack}>
              <span
                className={styles.barFill}
                style={{ width: barShare(bar.value, HOW_ASSISTANT_BARS) }}
              />
            </span>
            <span className={styles.barValue}>{bar.value}</span>
          </span>
        ))}
      </div>

      <div className={styles.sources}>
        {HOW_ASSISTANT_SOURCES.map((source) => (
          <span key={source.index} className={styles.source}>
            <span className={styles.cite}>{source.index}</span>
            <span className={styles.sourceName}>{`${source.customer} · ${source.company}`}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
